/**
 * ActionRail - the vertical right-hand action column (TikTok-style).
 *
 * A single heart "like" (tap repeatedly; the badge shows your like count and
 * 10 likes auto-saves the video), a favorite toggle, an NSFW-only chat button,
 * and share. Purely presentational: behaviour is delegated to the feed.
 */
import { formatCount } from '../lib/format.js';

function RailButton({ icon, label, count, badge, active, activeClass, onClick }) {
  return (
    <button
      type="button"
      class={`rail__btn ${active ? `rail__btn--active ${activeClass || ''}` : ''}`}
      onClick={onClick}
      aria-pressed={active ? 'true' : 'false'}
      aria-label={label}
    >
      <span class="rail__icon">
        {icon}
        {badge != null && <span class="rail__badge">{badge}</span>}
      </span>
      {count != null && <span class="rail__count">{count}</span>}
    </button>
  );
}

export function ActionRail({
  video,
  avatar,
  likeCount = 0,
  isFavorite,
  showChat = false,
  immersive = false,
  onLike,
  onToggleFavorite,
  onChat,
  onShare,
  onToggleImmersive,
}) {
  return (
    <div class="rail">
      {!immersive && avatar && (
        <div class="rail__author">
          <img class="rail__avatar" src={avatar} alt="" decoding="async" />
          <span class="rail__follow" aria-hidden="true">
            +
          </span>
        </div>
      )}

      {!immersive && (
        <RailButton
          icon="❤️"
          label="Like"
          badge={likeCount > 0 ? formatCount(likeCount) : null}
          active={likeCount > 0}
          activeClass="rail__btn--reacted"
          onClick={() => onLike(video.actualIndex)}
        />
      )}

      {!immersive && (
        <RailButton
          icon={isFavorite ? '⭐' : '☆'}
          label="Save to favorites"
          active={isFavorite}
          activeClass="rail__btn--saved"
          onClick={() => onToggleFavorite(video)}
        />
      )}

      {!immersive && showChat && (
        <RailButton icon="💬" label="Chat with author" onClick={() => onChat?.(video)} />
      )}

      {!immersive && <RailButton icon="↗" label="Share" onClick={() => onShare?.(video)} />}

      <RailButton
        icon={immersive ? '🗗' : '⛶'}
        label={immersive ? 'Show controls' : 'Hide controls'}
        onClick={() => onToggleImmersive?.()}
      />
    </div>
  );
}
